/* eslint-disable @typescript-eslint/no-extraneous-class */
export class VehicleNameFormatter {
  static removeYearFromModelName(
    vehicleName: string | null | undefined,
    isAudiMake: boolean,
  ): string | undefined {
    if (!vehicleName) return undefined;
    // Only slice if isAudiMake is true AND the name actually starts with "Audi "
    if (isAudiMake && vehicleName.startsWith('Audi ')) {
      return vehicleName.toString().slice(5);
    }
    return vehicleName;
  }

  static isAudiMake(vehicle?: any): boolean {
    return vehicle?.titleText?.includes('Audi') ?? false;
  }
}
